import { defineAsyncComponent } from 'vue'
export default {
  base: defineAsyncComponent(() => import("/app/apps/website/app/layouts/base.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/apps/website/app/layouts/default.vue").then(m => m.default || m)),
  menu: defineAsyncComponent(() => import("/app/apps/website/app/layouts/menu.vue").then(m => m.default || m))
}